<template>
  <div
    class="content-block history-block"
    data-aos="fade-up"
    data-aos-duration="800"
    data-aos-delay="300"
  >
    <div class="block-left">
      <div class="block-number">06</div>
      <BlockHeader title="发展历程" subtitle="" subtitleEn="DEVELOPMENT PATH" />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="history-content">
        <div class="history-image-container">
          <div class="image-wrapper">
            <img :src="historyImage" alt="太丰发展历程" class="history-image" />
            <div class="image-overlay"></div>
            <div class="image-decoration"></div>
          </div>

          <div class="image-caption">
            <h4 class="caption-title">太丰历史传承</h4>
            <p class="caption-text">
              跨越近百年的传承与发展，从传统工艺到现代技术，太丰始终坚持品质为本，创新为魂。
            </p>
            <div class="caption-details">
              <div class="detail-item">
                <span class="detail-label">创立年份</span>
                <span class="detail-value">1931年</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">历史里程碑</span>
                <span class="detail-value">8个关键阶段</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">品牌传承</span>
                <span class="detail-value">90余年</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from "../common/BlockHeader.vue";
export default {
  components: { BlockHeader },
  name: "HistoryBlock",
  data() {
    return {
      historyImage: require("@/assets/png/time-line.jpg"),
    };
  },
  methods: {},
};
</script>

<style scoped>
.history-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  min-height: 500px;
}

.history-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.history-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.history-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.history-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.history-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.history-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.history-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.history-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.history-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.history-image-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.image-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 25px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.image-wrapper:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.1);
  border-color: rgba(154, 27, 30, 0.2);
}

.history-image {
  width: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s;
}

.image-wrapper:hover .history-image {
  transform: scale(1.03);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(154, 27, 30, 0.03) 0%,
    rgba(154, 27, 30, 0.1) 100%
  );
  pointer-events: none;
}

.image-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(
    to right,
    transparent,
    #9a1b1e 30%,
    #b22222 70%,
    transparent
  );
  opacity: 0.6;
}

.image-caption {
  padding: 25px;
  background: white;
  border-radius: 10px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.03);
  transition: all 0.3s;
}

.image-caption:hover {
  border-color: rgba(154, 27, 30, 0.2);
  box-shadow: 0 5px 18px rgba(154, 27, 30, 0.08);
}

.caption-title {
  font-size: 1.5rem;
  color: #9a1b1e;
  margin-bottom: 15px;
  font-weight: 700;
  position: relative;
  padding-bottom: 10px;
}

.caption-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: #9a1b1e;
  border-radius: 2px;
}

.caption-text {
  font-size: 1rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 25px;
  text-align: justify;
}

.caption-details {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  border-top: 1px solid rgba(154, 27, 30, 0.1);
}

.detail-item {
  text-align: center;
  flex: 1;
  padding: 10px;
  background: rgba(154, 27, 30, 0.02);
  border-radius: 8px;
  transition: all 0.3s;
}

.detail-item:hover {
  background: rgba(154, 27, 30, 0.05);
  transform: translateY(-2px);
}

.detail-item:not(:last-child) {
  border-right: 1px solid rgba(154, 27, 30, 0.1);
  padding-right: 20px;
  margin-right: 20px;
}

.detail-label {
  display: block;
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 6px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.detail-value {
  display: block;
  font-size: 1.4rem;
  color: #9a1b1e;
  font-weight: 800;
}

@media (max-width: 1200px) {
  .history-block .block-left {
    flex: 0 0 250px;
  }

  .history-image {
    height: 380px;
  }
}

@media (max-width: 992px) {
  .history-block {
    flex-direction: column;
    min-height: auto;
  }

  .history-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .history-block .block-right {
    padding: 30px 25px;
  }

  .history-image {
    height: 350px;
  }
}

@media (max-width: 768px) {
  .history-block .block-left {
    padding: 25px 20px;
  }

  .history-block .block-right {
    padding: 25px 20px;
  }

  .history-block .block-title {
    font-size: 1.6rem;
  }

  .history-image {
    height: 300px;
  }

  .caption-title {
    font-size: 1.3rem;
  }

  .caption-text {
    font-size: 0.95rem;
  }

  .detail-value {
    font-size: 1.2rem;
  }
}

@media (max-width: 576px) {
  .history-image {
    height: 250px;
  }

  .image-caption {
    padding: 20px;
  }

  .caption-details {
    flex-direction: column;
    gap: 15px;
    padding-top: 15px;
  }

  .detail-item:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
    padding-right: 0;
    margin-right: 0;
    padding-bottom: 15px;
    margin-bottom: 0;
  }

  .detail-item {
    padding: 12px;
  }
}

.history-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(154, 27, 30, 0.03) 0%,
    transparent 70%
  );
  z-index: 0;
}

.history-block > * {
  position: relative;
  z-index: 1;
}

.image-wrapper {
  position: relative;
}

.image-wrapper::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border: 1px solid rgba(154, 27, 30, 0.2);
  border-radius: 12px;
  pointer-events: none;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
}

.image-wrapper:hover::before {
  opacity: 1;
}
</style>
